import { IMessage } from "react-stomp-hooks";

type AuthenticationMessageBody = {
  authenticated: boolean;
};
type EventSubscriptionMessageStatus = {
  status: string;
};

const FAILED_EVENT_SUB_STATUS = "FAILED";

export function IsAuthenticationSuccessful(message: IMessage): boolean {
  const authenticationMessage = parseToAuthenticationMessage(message.body);
  return authenticationMessage.authenticated;
}

export function IsEventSubscriptionSuccessful(message: IMessage): boolean {
  const eventSubscriptionMessageStatus = parseToEventSubscriptionMessage(
    message.body
  );
  return eventSubscriptionMessageStatus.status != FAILED_EVENT_SUB_STATUS;
}

function parseToEventSubscriptionMessage(
  messageBody: string
): EventSubscriptionMessageStatus {
  try {
    const jsonMessage = JSON.parse(messageBody);
    return {
      status: jsonMessage.status,
    };
  } catch (error) {
    return {
      status: FAILED_EVENT_SUB_STATUS,
    };
  }
}

function parseToAuthenticationMessage(
  messageBody: string
): AuthenticationMessageBody {
  try {
    const jsonMessage = JSON.parse(messageBody);
    return {
      authenticated: jsonMessage.authenticated,
    };
  } catch (error) {
    return {
      authenticated: false,
    };
  }
}
